import { Auth } from '@prismamedia/one-components';
import { Role } from '@prismamedia/one-user';
import { TagType } from '../__generated__/queries-web';

export const auth = new Auth(config.API_ONE_AUTH);

const ONE_AUTH_BASE_URL = config.API_ONE_AUTH.replace(/\/$/, '');

export const loginWithAzureIdToken = async (azureIdToken: string) => {
  const response = await fetch(`${ONE_AUTH_BASE_URL}/azure-login`, {
    headers: new Headers({
      Authorization: `Bearer ${azureIdToken}`,
    }),
    mode: 'cors',
    cache: 'default',
  });
  const payload = await response.json();
  if (!response.ok || !payload.id_token) {
    throw new Error(payload.message || 'Erreur de connexion');
  }

  // Auth de one-components n'expose que login() sur /login : pas de setter public
  // pour un JWT ONE obtenu via un autre endpoint.
  ((auth as unknown) as { _setJwt: (token: string) => void })._setJwt(
    payload.id_token,
  );
  return payload.id_token as string;
};

const hasWebAdminCreationRole = () =>
  !!auth.user &&
  (auth.user.isSuperAdmin() ||
    auth.user.isAdmin() ||
    auth.user.hasRole(Role.WebAdmin));

export const canCreateTag = (tagProviders: TagType[] = []) => {
  if (
    !auth.isAuthenticated() ||
    !tagProviders.find((tagProvider) => {
      return [TagType.Tag, TagType.Video].includes(tagProvider);
    })
  ) {
    return false;
  }

  return hasWebAdminCreationRole();
};

export const canSeeUnusedTags = () =>
  !!auth.user && (auth.user.isSuperAdmin() || auth.user.hasRole(Role.WebAdmin));

export const canCreateCategory = () =>
  auth.isAuthenticated() && hasWebAdminCreationRole();
